<template>
  <div class="container">
    <div class="main">
      <!-- banner开始 -->
      <div class="banner">
        <div class="img">
          <img src="@/assets/banner3.png" alt="" />
        </div>
        <div class="banner-title">
          <h3 class="slogan">携手坚持 共创奇迹</h3>
          <h3 class="sbu-text">PERSISTENCE &amp; MIRACLE</h3>
        </div>
      </div>
       <!-- banner结束 -->
       <!-- 公司福利开始 -->
      <div class="introduce benefits">
        <div class="content">
          <h3 class="h3-title">
            公司福利 <br />
            <span>CORPORATE BENEFITS</span>
          </h3>
          <ul class="welfare">
            <li>
              <div class="img1"></div>
              <span>高薪岗位</span>
            </li>
            <li>
              <div class="img2"></div>
              <span>业绩奖励</span>
            </li>
            <li>
              <div class="img3"></div>
              <span>带薪休假</span>
            </li>
            <li>
              <div class="img4"></div>
              <span>专业培训</span>
            </li>
          </ul>
        </div>
      </div>
       <!-- 公司福利结束 -->
       <!-- 招贤纳士开始 -->
      <div class="introduce recruit">
        <div class="post-list bg2">
          <div class="content">
            <h3 class="h3-title">招贤纳士 <br /><span>JOIN US</span></h3>
            <div class="post-list bg"></div>
          </div>
          <ul class="post-box">
            <li v-for="(item, index) in talents" :key="index">
              <h4>{{ item.jobName }}</h4>
              <p>
                {{ item.education }}<br />
                {{ item.suffer }}
              </p>
              <div>
                {{ item.dutyName }}:<br />
                <div v-for="(detail, val) in item.list" :key="val">
                  <p v-if="val == 0">{{ detail.content }}</p>
                </div>
              </div>
              <img src="@/assets/right.png" alt="" @click="show(item)" />
            </li>
          </ul>
        </div>
      </div>
      <!-- 招贤纳士结束 -->
      <!-- 底部开始 -->
      <div class="address flex flex-between">
        <div class="info-text address-item">
          <h3 class="p1">如果您对我们感兴趣，欢迎您加入年盈航空大家庭</h3>
          <div class="p2">
            <h3>简历投递</h3>
            应聘简历请发至 2881521410@qq.com
            <img src="@/assets/iconDelivery.png" alt="" />
          </div>
          <div class="p2">
            <h3>招聘岗位</h3>
            <span>人事经理</span> <span>销售经理</span> <span>夜班客服</span> <span>旅游计调</span>
            <img src="@/assets/iconRecruit.png" alt="" />
          </div>
          <div class="p2">
            <h3>联系人</h3>
            <p>覃女士</p>
            15978132261
            <img src="@/assets/iconContact.png" alt="" />
          </div>
        </div>
        <div class="amap-wrapper">
          <el-amap
            class="amap-box"
            :vid="'amap-vue'"
            :zoom="zoom"
            :center="center"
          >
            <el-amap-marker
              vid="marker"
              :position="center"
              :label="label"
            ></el-amap-marker>
          </el-amap>
        </div>
      </div>
      <!-- 底部结束 -->
    </div>
    <!-- 弹窗 -->
    <div class="dialog" v-show="bgShow" @click="close()">
      <div class="dialog-centent" v-show="iSshow">
        <div class="close" @click.stop="close(index)"></div>
        <div class="pointer">
          <h3>{{ details.jobName }}</h3>
          <p>{{ details.education }} | {{ details.suffer }}</p>
          <h4>{{ details.dutyName }}:</h4>
          <div>
            <span v-for="(item, num) in details.list" :key="num + '1'">{{
              item.content
            }}</span>
          </div>
          <h4>{{ details.working }}：</h4>
          <div>
            <span v-for="(work, num) in details.status" :key="num">{{
              work.centent
            }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "join",
  components: {},
  data() {
    return {
      iSshow: false,
      bgShow: false,
      details: [],
      zoom: 16,
      center: [108.37197, 22.766171],
      label: {
        content: "南宁年盈航空客货服务有限责任公司",
        offset: [-90, -26],
      },
      talents: [
        {
          jobName: "酒店业务经理（1人）",
          education: "大专及以上学历",
          suffer: "3年以上酒店资源整合相关工作经验",
          dutyName: "岗位职责",
          salary: "底薪5000-8000（视能力而定）+提成",
          working: "岗位要求",
          list: [
            {
              content:
                "1.通过电话沟通、直面约谈，对酒店进行考察评估、洽谈合作，并根据客户需求与竞争对手情况，制定合理的运营方案；",
            },
            {
              content:
                "2. 完成与商户从签约到上线过程中的沟通协调，合同信息录入等工作；",
            },
            {
              content:
                "3. 处理各类活动、价格调整、到期续签等日常运营事务； ",
            },
            {
              content:
                "4. 与商户保持紧密联系，推动商户积极参与促销活动，并协助客服解决客诉；",
            },
            {
              content:
                "5. 协助上级做好酒店业务市场和竟争对手信息的收集，维护好重点合作伙伴的长期合作关系",
            }
          ],
          status: [
            { centent: "1. 大专及以上学历；" },
            { centent: "2. 3年以上酒店资源整合相关工作经验；" },
            {centent:"3. 有酒店资源的从业背景者优先考虑；"},
            { centent: "4. 具备较强的谈判能力、沟通协调能力、客户管理能力；" },
            { centent:"5. 执行力强，有极强的责任心和服务意识，吃苦耐劳；"},
            { centent: "6. 善于总结和发现问题，有较强的学习能力。" },
          ],
        },
        {
          jobName: "销售经理（1人）",
          education: "大专及以上学历",
          suffer: "3年以上销售工作经验",
          dutyName: "岗位职责",
          salary: "5K-10K",
          working: "岗位要求",
          list: [
            { content: "1.负责南宁地区的客户开发；" },
            {
              content:
                "2. 根据公司的发展要求，发展代理商、开发企事业单位及个人客户；",
            },
            {
              content: "3. 按照公司的规划，多方位、多渠道寻找潜在的合作伙伴；",
            },
            { content: "4. 招聘、培训并管理本部门员工；" },
          ],
          status: [
            { centent: "1. 3年以上销售工作经验；" },
            { centent: "2. 有航空公司、票务中心、旅行社等经验者优先；" },
            { centent: "3. 年龄26-40岁，男女不限；" },
            { centent: "4. 人品端正，能承受较大的工作压力；" },
            { centent: "5. 语言组织及表达能力强，具有较强的市场开发能力；" },
            {
              centent:
                "6. 有丰富的组织管理经验，较强的责任感和团队精神，能吃苦；",
            },
            { centent: "7. 具备独立分析和解决问题的能力；" },
          ],
        },
        {
          jobName: "夜班客服（3人）",
          education: "大专及以上学历",
          suffer: "有1年以上相关工作经验",
          dutyName: "岗位职责",
          salary: "保底3K+提成",
          time: "18点-次日8点，上一休一",
          working: "岗位要求",
          list: [
            { content: "1.负责客户提供机票预订、机票退改签服务；" },
            {
              content:
                "2. 通过电话与客户进行有效沟通了解客户需求, 寻找销售机会并完成销售业绩。",
            },
          ],
          status: [
            { centent: "1.23-35岁，口齿清晰，普通话流利，语音富有感染力；" },
            { centent: "2. 对销售工作有较高的热情；" },
            { centent: "3. 具备较强的学习能力和优秀的沟通能力；" },
            {
              centent:
                "4. 有航空公司、客服中心、售票处、票务中心、旅行社、电话销售等工作经验者优先。",
            },
          ],
        },
        {
          jobName: "IT运维技术员（1人）",
          education: "大专及以上学历",
          suffer: "有2年相关工作经验",
          dutyName: "岗位职责",
          salary: "3K-5K",
          working: "岗位要求",
          list: [
            {
              content:
                "1.负责公司计算机软硬件、内部网络的安全运行及日常管理维护工作，同时为其他部门提供软硬件技术支持；",
            },
            {
              content:
                "2.负责公司其他办公设备的日常维护及管理；",
            },
            {
              content:"3.负责公司IT设备的采购和验收工作；"
            },
            {
              content:"4.负责公司内部信息系统日常使用过程中的问题反馈，准确定位问题，问题再现性测试分析，并跟进问题解决"
            }
          ],
          status: [
            { centent: "1.大专及以上学历，计算机相关专业，2年以上信息技术或网络管理相关工作经验。" },
            {
              centent:
                "2. 熟悉路由器，交换机、防火墙的网络设备的设置与管理；",
            },
            {
              centent:
                "3. 熟悉操作系统及应用程序安装，熟练应用各种常用办公软件；",
            },
            { centent: "4.学习能力强，具备良好的抗压能力，同时具备良好的团队合作精神和沟通协作能力；执行力强，具备良好的服务意识，安全保密意识强。" },
          ],
        },
      ],
    };
  },
  created() {},
  computed: {},
  methods: {
    show(data) {
      this.bgShow = true;
      this.details = data;
      this.iSshow = true;
    },
    close() {
      this.iSshow = false;
      this.bgShow = false;
    },
  },
  mounted() {
    this.$emit("childVal", 4);
  },
  destroy() {},
};
</script>
<style lang="less" scoped>
.main {
  .banner {
    position: relative;
    .img {
      width: 100%;
      height: 550px;
      
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
    .banner-title {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      text-align: center;
      h3 {
        font-size: 2rem;
        color: #fefefe;
      }
      .slogan {
        margin-bottom: 10px;
        font-weight: 700;
      }
      .sbu-text {
        color: #eaeaea;
        display: inline-flex;
        justify-content: center;
        font-size: 1.3rem;
      }
    }
  }
  .recruit {
    padding: 70px 0 0;
    background: #f4f4f5;
    .h3-title {
      font-size: 2rem;
      color: #333;
      text-align: center;
    }
    .bg2 {
      .content {
        width: 1240px;
        padding: 0 20px;
        margin: 0 auto;
        h3 {
          font-size: 2rem;
          color: #333;
          text-align: center;
          span {
            color: #666;
            font-size: 0.9rem;
            margin-top: 15px;
            display: flex;
            justify-content: center;
          }
        }
      }
      .post-box {
        display: flex;
        justify-content: space-between;
        width: 1200px;
        margin: 0 auto;
        padding: 70px 20px;
        li {
          cursor: pointer;
          flex: 1;
          h4 {
            font-size: 1.2rem;
            font-weight: 700;
            margin-bottom: 20px;
          }
          p,
          div {
            font-size: 0.9rem;
            color: #666;
            line-height: 1.6rem;
            margin-bottom: 20px;
          }
          div {
            margin-bottom: 50px;
            p {
              max-width: 250px;
              display: -webkit-box;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 1;
              overflow: hidden;
            }
          }
          img {
            width: 60px;
            height: 30px;
          }
        }
      }
    }
  }
  .benefits {
    padding: 70px 0 20px;
    background: #fefefe;
    .content {
      width: 1240px;
      padding: 0 20px;
      margin: 0 auto;
      .h3-title {
        font-size: 2rem;
        color: #333;
        text-align: center;
        margin-bottom: 40px;
        span {
          color: #666;
          font-size: 0.9rem;
          margin-top: 15px;
          display: flex;
          justify-content: center;
        }
      }
      .welfare {
        display: flex;
        flex-wrap: wrap;
        border-radius: 20px;
        width: 100%;
      
        li {
          display: flex;
          align-items: center;
          justify-content: center;
          flex-wrap: wrap;
          height: 210px;
          text-align: center;
          position: relative;
          flex-direction: column;
          flex: 1;
          &:last-child {
            border-bottom-right-radius: 20px;
            border-top-right-radius: 20px;
          }
          &first-child {
            border-bottom-left-radius: 20px;
            border-top-left-radius: 20px;
          }
          &:not(:last-child)::after{
             position: absolute;
            content: "";
            width: 1px;
            height: 70%;
            top: 50%;
            right: 0;
            transform: translateY(-50%);
            background: #e9e9e9;
          }
          .img1 {
            background: url(../../assets/high-red.png);
            background-size: 100% 100%;
          }
          .img2 {
            background: url(../../assets/option-red.png);
            background-size: 100% 100%;
          }

          .img3 {
            background: url(../../assets/education-red.png);
            background-size: 100% 100%;
          }
          .img4 {
            background: url(../../assets/train-red.png);
            background-size: 100% 100%;
          }
          span {
            font-size: 1.2rem;
            font-weight: 700;
            color: #404040;
          }
          div {
            width: 60px;
            height: 60px;
            margin: 0 auto 30px;
          }
        }
      }
    }
  }
  .address {
    width: 100%;
    .address-item {
      width: 50%;
      height: 560px;
    }
    .info-text {
      background: #ea5455;
      color: #fefefe;
      padding: 50px;
      text-align: right;
      .p1 {
        margin-bottom: 40px;
        line-height: 1.2rem;
      }
      h3 {
        color: #fefefe;
        text-align: right;
        font-size: 1.2rem;
        font-weight: 700;
      }
      .p2 {
        margin-bottom: 40px;
        position: relative;
        h3,
        p {
          margin-bottom: 10px;
        }
        img {
          position: absolute;
          top: -8px;
          right: -80px;
          width: 60px;
          z-index: 10;
        }
      }
    }
    .amap-wrapper {
      width: 50%;
      height: 560px;
    }
  }
}
.dialog {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
}
.dialog-centent {
  display: inline-block;
  background: #fefefe;
  position: relative;
  width: max-content;
  max-width: 1000px;
  min-width: 600px;
  box-shadow: 0 0 10px #ccc;
  border-radius: 10px;
  h3 {
    font-size: 1.2rem;
    color: #d81725;
    font-weight: 700;
    margin-bottom: 15px;
  }
  p {
    font-size: 0.9rem;
    color: #666;
    line-height: 1.2rem;
    margin-bottom: 25px;
  }
  h4 {
    font-size: 1.2rem;
    color: #404040;
    font-weight: 700;
    margin-bottom: 15px;
  }
  .close {
    position: absolute;
    top: 20px;
    right: 10px;
    font-size: 2rem;
    color: #d81725;
    padding: 5px;
    cursor: pointer;
    background: url(../../assets/close.png) no-repeat;
    background-size: 40px 40px;
    width: 40px;
    height: 40px;
  }
  .pointer {
    padding: 40px;
    overflow: auto;
    max-height: 80vh;
    border-radius: 10px;
    position: relative;
    z-index: 1000;
    &:last-child {
      margin-bottom: 0;
    }
    div {
      font-size: 0.9rem;
      color: #737373;
      line-height: 1.2rem;
      margin-bottom: 25px;
      word-break: break-all;
      span {
        display:block;
        line-height: 1.6rem;
      }
    }
  }
}
</style>
